// extracted by mini-css-extract-plugin
module.exports = {"expertDataAbout":"XkgQR","title":"_3zsO8","subTitle":"_21-_Q","content":"_3EQLF","blockedContent":"Z1yTg","contentSection":"_1eEk8","fullWidth":"_9ItUq"};